// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"errors_errorContainer__w7J_e"};